export const SET_GLOBAL = 'SET_GLOBAL';
export const SET_GLOBAL_SUCCESS = 'SET_GLOBAL_SUCCESS';
export const ERASE_BUFFER_GLOBAL = 'ERASE_BUFFER_GLOBAL';
export const ERASE_BUFFER_GLOBAL_SUCCESS = 'ERASE_BUFFER_GLOBAL_SUCCESS';